module.exports = __webpack_public_path__ + "img/netbarg.4a18d43.png";